import { Component } from '@angular/core';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
import { AppPermissionService } from 'app/core/services/app-permission.service';
import { PermissionResponse } from 'app/core/base-api';
import { FormatConfigService } from 'app/core/services/format-config.service';
import { CapiLoginService } from 'app/core/extension/login/capi-login-service';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { IntercapiPublicLayoutComponent } from '../intercapi-public-layout/intercapi-public-layout.component';
import { IntercapiLayoutComponent } from '../intercapi-layout/intercapi-layout.component';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import PermissionsEnum = PermissionResponse.PermissionsEnum;

@Component({
  selector: 'cap-app-decider',
  templateUrl: './app-decider.component.html',
  imports: [LoadingBarModule, IntercapiPublicLayoutComponent, IntercapiLayoutComponent, TranslatePipe]
})
export class AppDeciderComponent {
  public deploymentMode = environment.deploymentMode;
  private subscription: Subscription = new Subscription();
  private loginICPRequired: boolean = false;

  constructor(
    private permissionService: AppPermissionService,
    private router: Router,
    private appformatConfigService: FormatConfigService,
    private loginService: CapiLoginService
  ) {
    this.subscription.add(
      this.appformatConfigService.parameterConfig$.subscribe((config) => {
        this.loginICPRequired = <any>config?.parameters.ZUGELASSENE_BENUTZERKATEGORIEN === 'REGISTRIERT';
      })
    );
    const permission = this.getNecessaryPermission();
    if (loginService.userLoggedIn && !this.permissionService.hasPermission(permission) && permission !== PermissionsEnum.ANONYM) {
      this.router.navigate(['unauthorized']);
    }
  }

  private getNecessaryPermission(): PermissionResponse.PermissionsEnum {
    if (this.deploymentMode === 'PUBLIC') {
      if (!this.loginICPRequired) {
        return PermissionsEnum.ANONYM;
      }
      return PermissionsEnum.ICP_AUTHORIZED;
    } else if (this.deploymentMode === 'READ') {
      return PermissionsEnum.LOGIN;
    }
  }
}
